import {Component, Input, OnInit, Inject, ViewChild} from '@angular/core';
import {PlanStep} from '../../../services/PlanStep';
import {PlanCoordinate} from '../../../services/plan-coordinate';
import { IResource } from '../../../services/IResource';
import {StepComponent} from '../../step.component';
import { ResourceService } from '../../../services/resource.service';
import {Subscription} from 'rxjs/index';
import { DOCUMENT } from '@angular/common';
import {AttachmentUploadModalComponent} from '../../../../shared/components/attachment-upload-modal/attachment-upload-modal.component';
import {AppLoadingService} from '../../../../app-loading-panel/app-loading.service';
import {StrategiesPermissionsService} from '../../../services/strategies-permissions.service';

@Component({
  selector: 'app-explore-the-future',
  templateUrl: './explore-the-future.component.html',
  styleUrls: ['./explore-the-future.component.scss']
})
export class ExploreTheFutureComponent extends StepComponent<IResource> implements OnInit {

  private readonly HTTP_PREFIX_RE = /^https?:\/\//i;
  @ViewChild('attachmentUploadModal') private uploadModal: AttachmentUploadModalComponent;

  @Input() strategyId: number;

  constructor(@Inject(DOCUMENT) private document: Document,
                                private resourceService: ResourceService,
                                private appLoading: AppLoadingService,
                                private permService: StrategiesPermissionsService) {
    super(PlanCoordinate.stepBy(PlanStep.EXPLORE_THE_FUTURE), resourceService);
  }

  private resourcesSubscription: Subscription;
  resources: IResource[] = [];
  evidenceGroups;
  socialTrends;
  technologicalTrends;
  economicTrends;
  politicalTrends;


  ngOnInit() {
    if (!this.resourcesSubscription) {
      this.resourcesSubscription = this.resourceService.resources$.subscribe((newResources: IResource[]) => {
        this.resources = newResources.filter((resource: IResource) => {
          return resource.evidenceType.toUpperCase().indexOf('ETF') === 0;
        });
        this.groupByCategory();
        this.appLoading.clearLoading();
      });
    }
    this.resourceService.getResources(this.strategyId);
  }

  isViewer(): boolean {
    return this.permService.isUserViewer();
  }

  groupByCategory() {
    this.evidenceGroups = this.resources.reduce((result, item) => {

      const splits = item.evidenceType.split('-');

      const category = result[splits[1]] = result[splits[1]] || [];

      // Add current item to current category array
      category.push(item);

      // Return the result object for this iteration
      return result;

    }, {});
    this.socialTrends = {};
    this.technologicalTrends = {};
    this.economicTrends = {};
    this.politicalTrends = {};

    this.socialTrends = {
        'displayName': 'Social Trends',
        'files': this.evidenceGroups['ST'] ? this.evidenceGroups['ST'] : [{
          'name': ''}], 'value': 'ST'
      };
    this.technologicalTrends = {
        'displayName': 'Technological Trends',
        'files': this.evidenceGroups['TT'] ? this.evidenceGroups['TT'] : [{
                'name': ''}]
      };
    this.economicTrends = {
        'displayName': 'Economic Trends',
        'files': this.evidenceGroups['ET'] ? this.evidenceGroups['ET'] : [{
          'name': ''}], 'value': 'ET'
      };
    this.politicalTrends = {
        'displayName': 'Political Trends', 'value': 'PT',
        'files': this.evidenceGroups['PT'] ? this.evidenceGroups['PT'] : [{
          'name': ''}]
      };
  }

  onClickResource(resource: IResource) {
    if (resource.isUrl) {
      if (!resource.resourcePath.match(this.HTTP_PREFIX_RE)) {
        // if the URL is not prefixed with HTTP, then add it.
        resource.resourcePath = `http://${resource.resourcePath}`;
      }
      window.open(resource.resourcePath);
    } else {
      const iframe = this.document.createElement('iframe');
      iframe.src = this.resourceService.transformToResourceDownloadUrl(resource);
      this.document.body.appendChild(iframe);
      setTimeout(() => iframe.remove(), 1000);
    }
  }

  showAttachmentUploadModal(categoricalLocation) {
    this.uploadModal.show(categoricalLocation);
  }

  showAttachmentEditModal(event: { categoricalLocation: string,
    resource: IResource}) {
    this.uploadModal.edit(event.categoricalLocation, event.resource);
  }

  fetchData() {
    this.resourceService.getResources(this.strategyId);
  }

  editResource(resource: IResource) {
    this.appLoading.setLoading();
    this.resourceService.editResource(resource).subscribe((res) => {
        this.resourceService.getResources(this.strategyId);
        this.uploadModal.close();
        this.appLoading.clearLoading();
      }, (err) => {
        console.log('Edit Err: ', err);
        this.resourceService.getResources(this.strategyId);
        this.uploadModal.close();
        this.appLoading.clearLoading();
      }
    );
  }

}
